<template>
  <div class="app">
    <div class="banner">
      <img :src="storeBanner" alt="">
    </div>
    <div class="bg">
      <div class="neirong" v-if="true">
        <div class="th_title">
          <div class="cn">{{ pageData.t_name }}</div>
          <div class="en">{{ pageData.t_name_deputy }}</div>
        </div>
        <div class="imgBoxs">
          <div class="imgbox" v-for="item in boxList" :key="item.id" @click="clickBox(item)">
            <div class="img">
              <img :src="item.t_logo_main" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      pageData: {},
      boxList: [],
      storeBanner: ''
    }
  },
  methods: {
    clickBox(item) {

      axios({
        url: this.base_url.base_url + '/index.php/index/index/news_list?nid=11&cid=' + item.id,
        method: 'get',
      }).then((res) => {
        if (!res.data.data.news_data[0]) {
          1 == 1
        } else {
          this.$router.push('/xiangqing?nid=11&cid=' + item.id)
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    getData() {
      axios({
        url: this.base_url.base_url + '/index.php/index/index/navigation_list',
        method: 'get',
      }).then((res) => {
        this.pageData = res.data.data.bottom_list[2]
        this.storeBanner = res.data.data.top_list[2].banner_list[0].img
        this.boxList = this.pageData.child
      }).catch((err) => {
        console.log(err);
      })
    },
  },
  created() {
    this.getData()
  },
  mounted() { }
}
</script>

<style scoped lang="scss">
.app {

  height: 100%;

  .banner {
    img {
      width: 100%;
    }
  }

  .bg {
    margin-top: -6px;
    // background-image: url('@/assets/img/bg/storeBanner.png');
    background-size: cover;

    .neirong {
      padding-top: 50px;
      margin: 0 auto;
      width: 1344px;
      text-align: center;
      padding-bottom: 60px;

      .th_title {
        margin-bottom: 30px;

        .cn {
          font-size: 34px;
          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: 400;
          color: #333333;
        }

        .en {
          font-size: 16px;
          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: 400;
          color: #949594;
          line-height: 30px;
        }
      }

      .imgBoxs {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: 60px;
        width: 1344px;

        .imgbox {
          position: relative;
          width: 336px;
          height: 221px;
          background-image: url('@/assets/img/bg/pingchang.png');
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;
          cursor: pointer;



          .img {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -49%);

            img {
              width: 314px;
              height: 196px;
            }
          }
        }

        .imgbox:hover {
          background-image: url('@/assets/img/bg/2.png');
        }

        .imgbox:active {
          background-image: url('@/assets/img/bg/3.png');
        }
      }
    }
  }
}
</style>